import { render, staticRenderFns } from "./ArticlePage.vue?vue&type=template&id=0108ad34&scoped=true&"
import script from "./ArticlePage.vue?vue&type=script&lang=js&"
export * from "./ArticlePage.vue?vue&type=script&lang=js&"
import style0 from "./ArticlePage.vue?vue&type=style&index=0&id=0108ad34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0108ad34",
  null
  
)

export default component.exports